import { isPtacPathwaySettings } from '@alpinehomeair/common';
import { useAppSelector } from 'app/hooks';

export default function useIsPtacPathway(): boolean {
  return useAppSelector((state) =>
    isPtacPathwaySettings(state.project.projectSettings)
  );
}
